import React from 'react';
import './coachInfo.css';
import { useDispatch, useSelector } from "react-redux";
import { setCoachInfoAction } from "../../redux/actions";
import { COACH_INFO_INITIAL } from "../../redux/initialStateConstants";

const CoachInfo = () => {
    const dispatch = useDispatch();
    const coach_info = useSelector(state => state.coach_info);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                             onClick={ () => dispatch(setCoachInfoAction(COACH_INFO_INITIAL)) }
                        />
                        <div className="form__title">{ coach_info.name }</div>
                    </div>

                    { coach_info.photo && (
                        <div className="form__field">
                            <div className="coach__photo">
                                <img
                                    className="coach__photo-img"
                                    src={ coach_info.photo }
                                    alt={ coach_info.name }
                                />
                            </div>
                        </div>
                    ) }

                    { (coach_info.rating || coach_info.reviews_count > 0) && (
                        <div className="form__field coach__info">
                            <div className="coach__rating">
                                { coach_info.rating && (
                                    <>
                                        <span className="coach__rating-value">{ coach_info.rating }</span>
                                        <span className="coach__rating-star">★</span>
                                    </>
                                ) }
                                { coach_info.reviews_count > 0 && (
                                    <span className="coach__reviews-count">
                                ({ coach_info.reviews_count } отзывов)
                            </span>
                                ) }
                            </div>
                        </div>
                    ) }

                    { coach_info.links && coach_info.links.length > 0 && (
                        <div className="form__field coach__links">
                            { coach_info.links.map((item, index) => (
                                <a
                                    key={ index }
                                    className="coach__link"
                                    href={ item.link }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        className="coach__link-ico"
                                        src={ item.ico }
                                        alt="social"
                                    />
                                </a>
                            )) }
                        </div>
                    ) }

                    { (coach_info.phone || coach_info.email) && (
                        <div className="form__field coach__contacts">
                            { coach_info.phone && (
                                <div className="coach__contact">
                                    <span className="coach__contact-label">Телефон:</span>
                                    <a className="coach__contact-value" href={ `tel:${coach_info.phone}` }>
                                        { coach_info.phone }
                                    </a>
                                </div>
                            ) }
                            { coach_info.email && (
                                <div className="coach__contact">
                                    <span className="coach__contact-label">Email:</span>
                                    <a className="coach__contact-value" href={ `mailto:${coach_info.email}` }>
                                        { coach_info.email }
                                    </a>
                                </div>
                            ) }
                        </div>
                    ) }

                    { coach_info.description && (
                        <div className="form__field coach__description">
                            <div className="coach__description-title">Описание</div>
                            <div className="coach__description-text">
                                { coach_info.description }
                            </div>
                        </div>
                    ) }
                </div>
            </div>
        </div>
    );
};

export default CoachInfo;